
import React from 'react';
import { View, StyleSheet, Text, Image, TouchableOpacity } from 'react-native'
import '@expo/match-media'
import { useMediaQuery } from "react-responsive";
import { Icon } from 'react-native-elements'

import saOn from '../images/sa-sm.png'
import sexyOn from '../images/sexy-sm.png'
import saOff from '../images/sa-sm-off.png'
import sexyOff from '../images/sexy-sm-off.png'
import DotTable from './dot-table'
import makeTable from '../libs/baccaratTable'
import TextZ from './TextZ';

export default ({ data, disabled, selected, onClick, vip, vendor }) => {
    
    const isMobileDevice = useMediaQuery({    
        // maxDeviceWidth: 720,
        query: "(max-width: 720px)"
    });

    let table = data ? data.data.toUpperCase().split(',').filter(x => !!x) : []
    table = makeTable(table || []).slice(-10)

    let itemSize = '45%'
    
    // console.log(isMobileDevice)
    if (isMobileDevice) {
        itemSize = '95%'
    }

    let icon = saOn
    switch(vendor) {
        case 'sa':
            icon = disabled ? saOff : saOn;
            break;
        case 'sexy':
            icon = disabled ? sexyOff : sexyOn;
            break;
    }

    return <TouchableOpacity
        disabled={disabled}
        style={[{ width: itemSize,}, styles.container, disabled ? styles.disabled : {}, selected ? styles.selected: {}]}
        onPress={() => {
            if (disabled || selected) { 
                return 
            }
            onClick(data)
        }}
    >
        {data ? <>
            <View style={[styles.col1, { backgroundColor: disabled ? 'rgba(0,0,0,0.5)' : 'khaki' }]}>
                    <Image source={icon} style={styles.image}/>
                    <TextZ style={styles.label}>Baccarat {data.name}</TextZ>
                    {vip ? null : <TextZ style={[styles.label, { color: 'red' }]}>เฉพาะ VIP</TextZ>}
            </View>
            <View style={styles.col2}>
                <DotTable tableSize={16} width={400} table={table} />
            </View>
        </> : 
        <View style={styles.nonTable}>
            <Icon name='touch-app' color='brown' size={40}/>
            <TextZ style={{ color: 'brown', fontSize: 25 }}>กรอกผลเอง</TextZ>
        </View>
        }
    </TouchableOpacity>
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        margin: 5,
        borderRadius: 5,
        padding: 5,
        overflow: 'hidden',
        borderWidth: 2,
        backgroundColor: 'white',
        borderColor: 'khaki',
    },
    disabled: {
        backgroundColor: '#aaaaaa',
        borderColor: '#aaaaaa',
    },
    selected: {
        backgroundColor: 'khaki',

    },
    col1: {
        borderRadius: 5,
        padding: 5,
        flexDirection: 'column',
        flexGrow: 0,
    },
    col2: {
        flexDirection: 'column',
        flexGrow: 1,
    },
    image: {
        width: 125 * 0.4,
        height: 158 * 0.4,
    },
    label: {
        fontWeight: 'bold',
        color: 'white'
    },
    nonTable: {
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
    }
});
  

//<SATable 
//                        data={t}
//                        enable={vip && (t.percent > 0)}
//                        selected={game_room === t.name}
//                        onClick={SelectRoom} 
//                    />
  